import type { PercentagesWithTotal } from 'lumen/utils/constants/pi-constant-values';

/**
 * Rounds percentages to integer values
 * Makes sure it rounds to 100
 * @param  { Object } percentages : Contains win, meet and loss
 * @return { Object }               : Return the rounded pecentages
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function roundParityPercentages(
  percentages: PercentagesWithTotal,
) {
  const roundedPercentages = {
    win: 0,
    meet: 0,
    loss: 0,
    totalNbOfShops: 0,
  };

  // In case there are no shops, all percentages should default to 0
  if (percentages.totalNbOfShops === 0) {
    return roundedPercentages;
  }

  // Used floor for the percentages, this way we can't go over 100%
  roundedPercentages.loss = Math.round(percentages.loss * 100) / 100;
  roundedPercentages.meet = Math.round(percentages.meet * 100) / 100;

  // Kristof chose win as the value to be calculated instead of rounded since it is the least important of the three values
  const differenceWithTotal =
    1 - roundedPercentages.meet - roundedPercentages.loss;
  if (differenceWithTotal < 0) {
    if (roundedPercentages.meet > 0) {
      roundedPercentages.meet += differenceWithTotal;
    } else {
      roundedPercentages.loss += differenceWithTotal;
    }

    roundedPercentages.win = 0;
  } else {
    roundedPercentages.win = Math.round(differenceWithTotal * 100) / 100;
  }

  // Add number of shops to new percentages
  roundedPercentages.totalNbOfShops = percentages.totalNbOfShops;

  return roundedPercentages;
}
